module.exports = __webpack_public_path__ + "static/media/Landing-Page-X2.200b020f.png";